import {Injectable} from '@angular/core';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {NavController, NavParams} from 'ionic-angular';

import {Storage} from '@ionic/storage';
import {QuizzQuestionPage} from '../../pages/quizz-question/quizz-question';

/*
  Generated class for the QuizzProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class QuizzProvider {

  private quizz: any = null;
  private currentQuizz: any = null;

  constructor(
    private storage: Storage,
  ) {
    console.log('Hello QuizzProvider Provider');
  }

  doShowQuestion(navCtrl: NavController, navParams: NavParams) {
    navCtrl.setRoot(QuizzQuestionPage);
    navCtrl.popToRoot({
      animation: 'md-transition'
    }, () => {
      // Do nothing.
    });
  }

  // initiate(proof: any) {
  //   this.proof = proof;
  //   this.resetIdentificationQuestions();
  //   this.resetQuestions();
  // }

  // hasProof() {
  //   return (this.proof != null);
  // }

  // destroy() {
  //   this.proof = null;
  // }

  // getId() {
  //   return (this.proof) ? this.proof.id : null;
  // }

  // async resetIdentificationQuestions() {
  //   // let that = this;
  //   this.currentIdentificationQuestionIdx = -1;
  //   this.currentIdentificationQuestion = null;

  //   // await this.storage.get('userproof_' + this.proof.id + '_current_identification_question_idx').then((data: any) => {
  //   //   if (data) {
  //   //     that.currentIdentificationQuestionIdx = data;

  //   //     if ((that.proof.identificationQuestions.length - 1) < that.currentIdentificationQuestionIdx) {
  //   //       that.currentIdentificationQuestionIdx = (that.proof.identificationQuestions.length - 1);
  //   //     }
  //   //   }
  //   // });
  // }

  // async resetQuestions() {
  //   let that = this;
  //   this.currentQuestionIdx = -1;
  //   this.currentQuestion = null;

  //   await this.storage.get('userproof_' + this.proof.id + '_currentquestion_idx').then((data: any) => {
  //     if (data) {
  //       that.currentQuestionIdx = data;
  //       console.log("Current Question ------------>", data);
  //       if ((that.proof.questions.length - 1) < that.currentQuestionIdx) {
  //         that.currentQuestionIdx = (that.proof.questions.length - 1);
  //       }
  //     }
  //   });
  // }

  // getCurrentIdentificationQuestion(): any {
  //   this.currentIdentificationQuestion = null;

  //   if (this.currentIdentificationQuestionIdx === -1) {
  //     this.currentIdentificationQuestionIdx = 0;
  //   }

  //   if ((this.proof.identificationQuestions.length - 1) >= this.currentIdentificationQuestionIdx) {
  //     this.currentIdentificationQuestion = this.proof.identificationQuestions[this.currentIdentificationQuestionIdx];
  //   }

  //   return this.currentIdentificationQuestion;
  // }

  // getNextIdentificationQuestion(): any {
  //   this.currentIdentificationQuestion = null;

  //   if ((this.proof.identificationQuestions.length - 1) > this.currentIdentificationQuestionIdx) {
  //     this.currentIdentificationQuestionIdx++;
  //     // this.storage.set('userproof_' + this.proof.id + '_current_identification_question_idx', this.currentIdentificationQuestionIdx);
  //     this.currentIdentificationQuestion = this.proof.identificationQuestions[this.currentIdentificationQuestionIdx];
  //   }

  //   return this.currentIdentificationQuestion;
  // }

  // getCurrentIdentificationQuestionIdx() {
  //   return this.currentIdentificationQuestionIdx;
  // }

  // getIdentificationQuestionsTotal() {
  //   return this.proof.identificationQuestions.length;
  // }

  // getCurrentQuestion(): any {
  //   this.currentQuestion = null;

  //   if (this.currentQuestionIdx === -1) {
  //     this.currentQuestionIdx = 0;
  //   }

  //   if ((this.proof.questions.length - 1) >= this.currentQuestionIdx) {
  //     this.currentQuestion = this.proof.questions[this.currentQuestionIdx];
  //   }

  //   return this.currentQuestion;
  // }

  // getNextQuestion(): any {
  //   this.currentQuestion = null;

  //   if ((this.proof.questions.length - 1) > this.currentQuestionIdx) {
  //     this.currentQuestionIdx++;
  //     this.storage.set('userproof_' + this.proof.id + '_currentquestion_idx', this.currentQuestionIdx);
  //     this.currentQuestion = this.proof.questions[this.currentQuestionIdx];
  //   }

  //   return this.currentQuestion;
  // }

  // getCurrentQuestionIdx() {
  //   console.log("getCurrentQuestionIdx", this.currentQuestionIdx);
  //   return this.currentQuestionIdx;
  // }

  // getQuestionsTotal() {
  //   return this.proof.questions.length;
  // }

  // getTerms() {
  //   return this.proof.terms;
  // }

  // async getDuration() {
  //   let that = this;

  //   await this.storage.get('userproof_' + this.proof.id + '_duration').then((data: any) => {
  //     if (data) {
  //       that.proof.duration = data;
  //     }
  //   });

  //   return this.proof.duration;
  // }

  // setDuration(duration: number) {
  //   if (this.proof) {
  //     this.proof.duration = duration;
  //     this.storage.set('userproof_' + this.proof.id + '_duration', duration);
  //   }
  // }

  // getAdvice() {
  //   return this.proof.advice;
  // }

  // isWebcamRequired() {
  //   return this.proof.webcamRequired;
  // }

  // setWebcamRequired(webcamRequired: boolean) {
  //   this.proof.webcamRequired = true;
  // }

  // addIdentificationAnswer(questionId: number, answerId: any, callback: any) {
  //   if (answerId) {
  //     let questionAnswer = new QuestionAnswer();
  //     questionAnswer.kind = 'IQTA';
  //     questionAnswer.id = questionId;
  //     questionAnswer.answerId = parseInt(answerId, 10);
  //     questionAnswer.captured = this.dateTimeProvider.getISOString();

  //     this.storage.set('userproof_' + this.proof.id + '_identification_question_' + questionAnswer.id, JSON.stringify(questionAnswer));
  //   }

  //   if (callback) {
  //     callback();
  //   }
  // }

  // addAnswer(questionId: number, answerId: any) {
  //   if (answerId) {
  //     let questionAnswer = new QuestionAnswer();
  //     questionAnswer.kind = 'QTA';
  //     questionAnswer.id = questionId;
  //     questionAnswer.answerId = parseInt(answerId, 10);
  //     questionAnswer.captured = this.dateTimeProvider.getISOString();

  //     this.storage.set('userproof_' + this.proof.id + '_question_' + questionAnswer.id, JSON.stringify(questionAnswer));
  //   }
  // }

  // isFinished(_proof: any = null): Observable<boolean> {
  //   let that = this;

  //   if (!_proof) {
  //     _proof = that.proof;
  //   }

  //   return Observable.create((observer: any) => {
  //     if (_proof) {
  //       that.storage.get('userproof_' + _proof.id + '_finished').then((value: boolean) => {
  //         if (value) {
  //           that.storage.get('userproof_' + _proof.id).then((value: any) => {
  //             if (value) {
  //               that.proof = JSON.parse(value);
  //             }
  //           }).catch((error: any) => {
  //             console.log('Error on fetch proof', error);
  //           });

  //           observer.next(true);
  //           observer.complete();
  //         } else {
  //           observer.next(false);
  //           observer.complete();
  //         }
  //       }).catch((error: any) => {
  //         console.log(error);
  //         observer.next(false);
  //         observer.complete();
  //       });
  //     } else {
  //       observer.next(false);
  //       observer.complete();
  //     }
  //   });
  // }

  // async setFinished() {
  //   await this.storage.set('userproof_' + this.proof.id + '_finished', true);
  // }

  // getAnswersAndSituations(): Observable<Promise<any>[]> {
  //   let that = this;

  //   return Observable.create(observer => {
  //     that.storage.keys().then((keys: string[]) => {
  //       const promises = [];

  //       keys.forEach((key: string) => {
  //         if ((key.includes('userproof_' + that.proof.id + '_identification_question')) || (key.includes('userproof_' + that.proof.id + '_question'))) {
  //           promises.push(that.storage.get(key));
  //         }
  //       });

  //       observer.next(promises);
  //       observer.complete();
  //     }).catch((error: any) => {
  //       observer.error(new Error(error));
  //     });
  //   });
  // }

  // addSituation(situation: QuestionSituation, onFinish: any = null) {
  //   if (situation) {
  //     this.storage.set(
  //       'userproof_' + this.proof.id + '_question_' +
  //       this.dateTimeProvider.getString(),
  //       JSON.stringify(situation)).then(() => {
  //         if (onFinish) {
  //           onFinish();
  //         }
  //       }).catch((error: any) => {
  //         if (onFinish) {
  //           onFinish(error);
  //         }
  //       })
  //   }
  // }

  // isWebWithoutCamera(): boolean {
  //   let result = false;

  //   try {
  //     result = ((this.proof.accessKind === 'WEB') && (!this.proof.webcamRequired));
  //   } catch(e) {
  //     // do nothing.
  //   }

  //   return result;
  // }

}



// WEBPACK FOOTER //
// ./src/providers/quizz/quizz.ts